import React, { Component } from "react";
import { withTranslation } from "react-i18next";

const newsletters = [
    {
        id: 1,
        iconClass: "flaticon-open-book",
        titleKey: "NewsLetters_Title_08",
        file: "/static/pdf/newsletters/newsletter-2026-term-1.pdf",
    },
];

class NewsLetters2025Content extends Component {
    state = {
        currentPage: 1,
        itemsPerPage: 8,
    };

    render() {
        const { t } = this.props;
        const { currentPage, itemsPerPage } = this.state;

        // ------- 分页逻辑 -------
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = newsletters.slice(
            indexOfFirstItem,
            indexOfLastItem
        );

        const totalPages = Math.ceil(
            newsletters.length / itemsPerPage
        );

        return (
            <>
                <div className="row">
                    {currentItems.map(item => (
                        <div key={item.id} className="col-lg-3 col-md-6">
                            <a
                                href={item.file}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <div className="services-bx text-left m-b30">
                                    <div className="feature-lg text-white m-b30">
                                        <span className="icon-cell">
                                            <i className={item.iconClass}></i>
                                        </span>
                                    </div>

                                    <div className="icon-content">
                                        <h4 className="ttr-tilte">
                                            {t(item.titleKey)}
                                        </h4>
                                    </div>

                                    <div className="service-no">
                                        {item.id.toString().padStart(2, "0")}
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>

                {/* -------- 分页按钮 -------- */}
                <div className="pagination-wrapper text-center m-t30">
                    {[...Array(totalPages)].map((_, index) => {
                        const page = index + 1;

                        return (
                            <button
                                key={page}
                                onClick={() =>
                                    this.setState({ currentPage: page })
                                }
                                className={`btn m-1 ${
                                    page === currentPage
                                        ? "pagination-active"
                                        : "pagination-inactive"
                                }`}
                            >
                                {page}
                            </button>
                        );
                    })}
                </div>
            </>
        );
    }
}

export default withTranslation()(NewsLetters2025Content);
